import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  //mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: r => require(['@/views/layouts/App'], r),
      children: [
        {
          path: '/',
          redirect: '/word'
        },
        {
          path: '/kexercise/:knowtype',
          name: 'know-exrcise',
          component: r => require(['@/components/exercise/ExerciseList'], r),
          props: true
        },
        {
          path: '/exercise/index',
          name: 'exrcise',
          component: r => require(['@/components/exercise/ExerciseList'], r)
        },
        {
          path: '/exercise/check',
          name: 'exrcisecheck',
          component: r => require(['@/components/exercise/ExerciseCheck'], r)
        },
        {
          path: '/exercise/qa',
          name: 'exrciseqalist',
          component: r => require(['@/components/exercise/ExerciseQaList'], r)
        },
        {
          path: '/exercise/type',
          name: 'exrcise-type',
          component: r => require(['@/components/exercise/TypeList'], r)
        },
        {
          path: '/exercise/files',
          name: 'exrcise-files',
          component: r => require(['@/components/exercise/ExerciseFileList'], r)
        },
        {
          path: '/kewen',
          name: 'kewen',
          component: r => require(['@/components/kewen/KewenList'], r)
        },
        {
          path: '/kewen/role',
          name: 'kewen-role',
          component: r => require(['@/components/kewen/KewenRoleList'], r)
        },
        {
          path: '/word',
          name: 'word',
          component: r => require(['@/components/word/WordList'], r)
        },
        {
          path: '/grammar',
          name: 'grammar',
          component: r => require(['@/components/grammar/GrammarList'], r)
        },
        {
          path: '/grammartype',
          name: 'grammartype',
          component: r => require(['@/components/grammar/GrammarTypeTree'], r)
        },
        {
          path: '/lesson',
          name: 'lesson',
          component: r => require(['@/components/lesson/LessonList'], r)
        },
        {
          path: '/lesson/:id',
          name: 'lesson-view',
          component: r => require(['@/components/lesson/LessonView'], r)
        },
        {
          path: '/collection',
          name: 'collection',
          component: r => require(['@/components/lesson/unitsv2/LessonCollection'], r)
        },
        {
          path: '/collection/:id',
          name: 'collectionview',
          component: r => require(['@/components/lesson/unitsv2/LessonEntities'], r)
        },
        {
          path: '/locale/:group',
          name: 'locale-view',
          component: r => require(['@/views/locale/Locale'], r),
          props: true
        },
        {
          path: '/translate/index',
          name: 'translate-view',
          component: r => require(['@/views/locale/TranslateList'], r),
          props: true
        },
        {
          path: '/pinyin',
          name: 'pinyin-view',
          component: r => require(['@/views/pinyin/PinyinList'], r)
        },
        {
          path: '/pinyinintro',
          name: 'pinyin-intro',
          component: r => require(['@/views/pinyin/IntroList'], r)
        },
        {
          path: '/pinyinlesson',
          name: 'pinyin-lesson',
          component: r => require(['@/views/pinyin/LessonList'], r)
        },
        {
          path: '/pinyinlesson/:id',
          name: 'pinyin-lesson-items',
          component: r => require(['@/views/pinyin/LessonItems'], r)
        },
        {
          path: '/pinyinexercises',
          name: 'pinyin-exrs',
          component: r => require(['@/views/pinyin/exr/ExerciseList'], r)
        },
        {
          path: '/pinyincomb',
          name: 'pinyin-comb',
          component: r => require(['@/views/pinyin/CombList'], r)
        },
        {
          path: '/dataupdate',
          name: 'dataupdate',
          component: r => require(['@/views/data/Sentence'], r)
        },
        {
          path: '/testexercise/:type',
          name: 'testexercise',
          component: r => require(['@/views/test/TestExercise'], r),
          props: true
        },
        {
          path: '/dict/index',
          name: 'dict',
          component: r => require(['@/views/dict/Dictionary'], r),
        },
        {
          path: '/dict/missing',
          name: 'dictmissing',
          component: r => require(['@/views/dict/DictionaryMissing'], r),
        },
        {
          path: '/sentence',
          name: 'sentence',
          component: r => require(['@/views/sentence/SentenceList'], r),
        },
        {
          path: '/graphictext',
          name: 'graphictext',
          component: r => require(['@/views/graphic/GraphicTextList'], r),
        },
        {
          path: '/talk/topics',
          name: 'talktopic',
          component: r => require(['@/views/talk/TopicList'], r),
        },
        {
          path: '/talk/words',
          name: 'talkword',
          component: r => require(['@/views/talk/WordList'], r),
        },
        {
          path: '/review/sentences',
          name: 'reviewsentences',
          component: r => require(['@/views/review/KnowlSentences'], r),
        },
        {
          path: '/aiimage/word',
          name: 'aiimageword',
          component: r => require(['@/views/aiimage/word/WordList'], r)
        },
        {
          path: '/aiimage/sentence',
          name: 'aiimagesentence',
          component: r => require(['@/views/aiimage/sentence/SentenceList'], r)
        },
      ]
    },
    {
      path: '/login',
      name: 'Login',
      component: r => require(['@/views/Login'], r),
    },
    {
      path: '/outsite/exercise/:eid',
      name: 'outsite_exercise',
      component: r => require(['@/components/exercise/ExercisePreview'], r),
      props: true
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})
